import { EXTRAS_ANCILLARY_PACK_PAAA, EXTRAS_ANCILLARY_PACK_PAAB, EXTRAS_ANCILLARY_PACK_PAAC, EXTRAS_ANCILLARY_PACK_PAAD, EXTRAS_ANCILLARY_PACK_PAAE, EXTRAS_ANCILLARY_PACK_PAAF, EXTRAS_ANCILLARY_PACK_PAAG, EXTRAS_ANCILLARY_PACK_PAAH, EXTRAS_ANCILLARY_PACK_PAAI, EXTRAS_ANCILLARY_PACK_PAAO, EXTRAS_ANCILLARY_PACK_PAAQ, EXTRAS_ANCILLARY_PACK_PAAT, EXTRAS_ANCILLARY_PACK_PAAR, EXTRAS_ANCILLARY_PACK_PBAA, EXTRAS_ANCILLARY_PACK_PBAB, EXTRAS_ANCILLARY_PACK_PBAT, EXTRAS_ANCILLARY_PREF_BOARD, FLIGHT_MEAL_AVAILABILITY_URL_EXTENSION, MOCK_URL_RETRIEVE_FLIGHT_MEALS_AVAILABILITY, URL_RETRIEVE_FLIGHT_MEALS_AVAILABILITY } from './../configs/app-settings.indra.config';
import { HttpClient } from '@angular/common/http';
import { MOCK_STATUS, URL_FARE_INFORAMATIONTAC, MOCK_URL_FARE_INFORAMATIONTAC, PAX_TYPE_ADULT, PAX_TYPE_CHILD, PAX_TYPE_INFANT, PAX_TYPE_YOUNG_ADULT, PASSENGER_TYPE_TO_CODE_MAP, BASIC_ANCILLARY_CODES_MILES, BASIC_ANCILLARY_CODES_HAND_BAGGAGE, BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE, BASIC_ANCILLARY_CODES_SEAT_RESERVATION, BASIC_ANCILLARY_CODES_MEALS, BASIC_ANCILLARY_CODES_PREMIUM_BOARDING, BASIC_ANCILLARY_CODES_FASTTRACK, BASIC_ANCILLARY_CODES_FLIGHT_CHANGES, BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS, BASIC_ANCILLARY_CODES_PREMIUM_CUSTOMER_CENTER, BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN, BASIC_ANCILLARY_CODES_LOUNGE, BASIC_ANCILLARY_CODES_FLIGHT_CANCELLATION, BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE, BASIC_ANCILLARY_CODES_PREMIUM_BAGGAGE, BASIC_ANCILLARY_CODES_KIOSK, ANCILLARY_GROUP_HAND_BAGGAGE_LIST, ANCILLARY_GROUP_HOLD_BAGGAGE_LIST, ANCILLARY_GROUP_SEAT_RESERVATION_LIST, ANCILLARY_GROUP_FAST_TRACK_LIST, ANCILLARY_GROUP_MEAL_LIST, ANCILLARY_GROUP_PREMIUM_BOARDING_LIST, ANCILLARY_GROUP_PRIORITY_CHECK_IN_LIST, ANCILLARY_GROUP_PREMIUM_CUSTOMER_CENTER_LIST, ANCILLARY_GROUP_LOUNGE_LIST, ANCILLARY_GROUP_KIOSK_LIST, ANCILLARY_GROUP_PRIORITY_BAGGAGE_LIST, ANCILLARY_GROUP_MILES_LIST, MOCK_URL_FARE_INFORAMATIONTAC_EXTRA_ECONOMY, MOCK_URL_BFM_ANCILLARIES, URL_ROOT, SSR_CODES_CATALOG_EXCLUDED_LIST, EXTRAS_ANCILLARY_HOTEL, EXTRAS_ANCILLARY_CAR, EXTRAS_ANCILLARY_SEAT, EXTRAS_ANCILLARY_BAG, EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_MEAL, EXTRAS_ANCILLARY_ANIMAL, EXTRAS_ANCILLARY_FAST_TRACK, EXTRAS_ANCILLARY_LOUNGE, EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_INSURANCE, EXTRAS_ANCILLARY_TOURS, EXTRAS_ANCILLARY_PERSONAL_ASSISTANCE, EXTRAS_ANCILLARY_PARKING, EXTRAS_ANCILLARY_CARBON_OFFSET, EXTRAS_ANCILLARY_GUARANTEE_FUND, MOCK_URL_CARBON_OFFSET, MOCK_URL_CHUBB_INSURANCE_PLANS, URL_CHUBB_INSURANCE_PLANS, URL_REMOVE_EXTERNAL_RESERVATION, MOCK_URL_INSURANCE_RESERVATIONS, URL_BFM_EXTERNAL_RESERVATION, EXTRAS_ANCILLARY_STOPOVER_LISBOA_CARD, MOCK_URL_LISBOA_CARD, EXTRAS_ANCILLARY_STOPOVER_AIRPORT_TRANSFERS, MOCK_URL_AIRPORT_TRANSFERS, EXTRAS_ANCILLARY_STOPOVER_SIGHTSEEING_TOURS, MOCK_URL_SIGHTSEEING_TOURS, MOCK_URL_DANISH_FUND, URL_REMOVE_ALL_EXTERNAL_RESERVATION, URL_REMOVE_SPECIFIC_EXTERNAL_RESERVATION, URL_REMOVE_EXTERNAL_RESERVATION_BY_EXTRA_INFO } from '@ibe.config';
import { PURCHASED_ANCILLARY_BAG, PURCHASED_ANCILLARY_EQUIPMENT, PURCHASED_ANCILLARY_EXTRA_MEAL, PURCHASED_ANCILLARY_EXTRA_ANIMAL, PURCHASED_ANCILLARY_EXTRA_FAST_TRACK, PURCHASED_ANCILLARY_EXTRA_LOUNGE, PURCHASED_ANCILLARY_EXTRA_MUSICAL, PURCHASED_ANCILLARY_SEAT, PURCHASED_ANCILLARY_PREF_BOARD, PURCHASED_ANCILLARY_PACK_PAAG, PURCHASED_ANCILLARY_PACK_PAAB, PURCHASED_ANCILLARY_PACK_PAAA, PURCHASED_ANCILLARY_PACK_PAAI, PURCHASED_ANCILLARY_PACK_PAAQ, PURCHASED_ANCILLARY_PACK_PAAD, PURCHASED_ANCILLARY_PACK_PAAE, PURCHASED_ANCILLARY_PACK_PAAF, PURCHASED_ANCILLARY_PACK_PAAC, PURCHASED_ANCILLARY_PACK_PAAH, PURCHASED_ANCILLARY_PACK_PAAR, PURCHASED_ANCILLARY_PACK_PBAT, PURCHASED_ANCILLARY_PACK_PBAA, PURCHASED_ANCILLARY_PACK_PBAB, PURCHASED_ANCILLARY_PACK_PAAO, PURCHASED_ANCILLARY_PACK_PAAT, } from '@ibe.components/shared/flight-brand-features-list/features.indra';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRA_getFeatureForTAC } from '@ibe.components/booking/flights/brand/brand.indra';
import { INDRACarbonOffsetResponse } from '@ibe.models/carbon-offset.indra.model';
import { INDRAInsuranceResponse } from '@ibe.models/insurance.indra.model.lib';
import { INDRAParallelService } from './parallel.indra.service';
import { finalize } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./api.indra.service";
import * as i3 from "./booking.indra.service";
import * as i4 from "./parallel.indra.service";
var INDRAAncillariesService = /** @class */ (function () {
    function INDRAAncillariesService(http, api, bookingService, parallelService) {
        this.http = http;
        this.api = api;
        this.bookingService = bookingService;
        this.parallelService = parallelService;
    }
    /************ API calls (NOTE: put API calls here) ******************/
    INDRAAncillariesService.prototype.INDRA_getAncillaries = function (pnr) {
        var _this = this;
        if (MOCK_STATUS.ANCILLARIES_CATALOG) {
            return this.http.get(MOCK_URL_BFM_ANCILLARIES);
        }
        else {
            this.parallelService.INDRA_setIsCatalogueApiLoading(true);
            return this.api.INDRA_get(URL_ROOT + "booking/pnrs/" + pnr + "/ancillaries/catalogue")
                .pipe(finalize(function () { return _this.parallelService.INDRA_setIsCatalogueApiLoading(false); }));
        }
    };
    INDRAAncillariesService.prototype.INDRA_getAncillariesForConfirmationPage = function (pnr) {
        if (MOCK_STATUS.ANCILLARIES_CATALOG) {
            return this.http.get(MOCK_URL_BFM_ANCILLARIES);
        }
        else {
            return this.api.INDRA_get(URL_ROOT + "booking/pnrs/" + pnr + "/ancillaries/catalogue?confirmationPage=true");
        }
    };
    INDRAAncillariesService.prototype.INDRA_getFareInformationTAC = function (request) {
        if (MOCK_STATUS.FARE_INFORAMATIONTAC) {
            return this.http.get(MOCK_URL_FARE_INFORAMATIONTAC);
        }
        else {
            if (MOCK_STATUS.FARE_INFORMATIONTAC_EXTRAECONOMY && request.fareFamily.includes('PLUSNEW')) {
                return this.http.get(MOCK_URL_FARE_INFORAMATIONTAC_EXTRA_ECONOMY);
            }
            else {
                return this.api.INDRA_post(URL_FARE_INFORAMATIONTAC, request);
            }
        }
    };
    INDRAAncillariesService.prototype.INDRA_getInsurancePlan = function (request) {
        if (MOCK_STATUS.CHUBB_INSURANCE_PLANS) {
            return this.http.get(MOCK_URL_CHUBB_INSURANCE_PLANS);
        }
        else {
            return this.api.INDRA_post(URL_CHUBB_INSURANCE_PLANS, request);
        }
    };
    INDRAAncillariesService.prototype.INDRA_retrieveFlightMealsAvailability = function (pnr, segmentId) {
        if (MOCK_STATUS.RETRIEVE_FLIGHT_MEALS_AVAILABILITY) {
            return this.http.get(MOCK_URL_RETRIEVE_FLIGHT_MEALS_AVAILABILITY);
        }
        else {
            return this.api.INDRA_get(URL_RETRIEVE_FLIGHT_MEALS_AVAILABILITY + pnr + FLIGHT_MEAL_AVAILABILITY_URL_EXTENSION + segmentId);
        }
    };
    /************************* API calls end *************************/
    /**
     * This massages the data to remove the ancillary codes that will be excluded for the catalog items..
     * @param ancillaryData: INDRAAncillary
     */
    INDRAAncillariesService.prototype.INDRA_removeExcludedCatalogAncillaries = function (ancillaryData) {
        var excludedList = SSR_CODES_CATALOG_EXCLUDED_LIST;
        if (ancillaryData && ancillaryData.bundleList) {
            ancillaryData.bundleList.forEach(function (bundle, index) {
                // exclude third party ancillaries due to difference in structure and usage
                var newBundleList = bundle.ancillaryList.filter(function (ancillary) {
                    return !(ancillary.type === EXTRAS_ANCILLARY_HOTEL ||
                        ancillary.type === EXTRAS_ANCILLARY_CAR ||
                        ancillary.type === EXTRAS_ANCILLARY_INSURANCE ||
                        ancillary.type === EXTRAS_ANCILLARY_TOURS ||
                        ancillary.type === EXTRAS_ANCILLARY_PERSONAL_ASSISTANCE ||
                        ancillary.type === EXTRAS_ANCILLARY_PARKING ||
                        ancillary.type === EXTRAS_ANCILLARY_CARBON_OFFSET ||
                        ancillary.type === EXTRAS_ANCILLARY_GUARANTEE_FUND);
                });
                if (newBundleList.length > 0) {
                    bundle.ancillaryList = newBundleList;
                    if (bundle.ancillaryList.length > 0) {
                        bundle.ancillaryList.forEach(function (ancillary) {
                            if (ancillary.catalog && ancillary.catalog.length > 0) {
                                ancillary.catalog.forEach(function (catalog) {
                                    if (catalog.passengers && catalog.passengers.length > 0) {
                                        catalog.passengers.forEach(function (passenger) {
                                            var newCodeList = passenger.codeList.filter(function (codeItem) { return !excludedList.includes(codeItem.code); });
                                            passenger.codeList = newCodeList;
                                        });
                                    }
                                });
                            }
                        });
                    }
                }
                else {
                    ancillaryData.bundleList.splice(index, 1);
                }
            });
        }
        return ancillaryData;
    };
    /**
      * This massages the data to exclude the catalogItems based from passenger's SSR
      * @param ancillaryData: INDRAAncillary
    */
    INDRAAncillariesService.prototype.INDRA_filterCatalog = function (ancillaryData, passengers) {
        var _this = this;
        if (ancillaryData && ancillaryData.bundleList) {
            var bundleIndexPurgeList_1 = [];
            ancillaryData.bundleList.forEach(function (bundleItem, bundleIndex) {
                if (bundleItem.ancillaryList) {
                    bundleItem.ancillaryList.forEach(function (ancillaryItem) {
                        var feature = _this.INDRA_getAncillaryConfig(ancillaryItem.type);
                        if (feature && ancillaryItem.catalog) {
                            var catalogIndexPurgeList_1 = [];
                            ancillaryItem.catalog.forEach(function (catalogItem, catalogIndex) {
                                var flightId = catalogItem.flightId.toString();
                                var paxIndexPurgeList = [];
                                if (catalogItem.passengers && catalogItem.passengers.length > 0) {
                                    catalogItem.passengers.forEach(function (paxItem, paxIndex) {
                                        var eligible = true;
                                        if (paxItem.paxId) {
                                            var filteredPassengers = passengers.filter(function (pax) { return pax.idPax.toString() === paxItem.paxId.toString(); });
                                            if (!(filteredPassengers &&
                                                filteredPassengers[0] &&
                                                _this.INDRA_isPassengerPrmEligible(filteredPassengers[0], feature.ineligibleSSR) &&
                                                // this.INDRA_isFlightFareInfoEligible(flightFareInfomation, feature.ineligibleSSR) &&
                                                _this.INDRA_isCurrentPurchasedAncillariesEligible(flightId, catalogItem.segmentId.toString(), paxItem.paxId.toString(), feature.ineligibleSSR))) {
                                                eligible = false;
                                            }
                                        }
                                        if (!eligible || !paxItem.paxId) {
                                            // removes passenger if not eligible for catalog items..
                                            // catalogItem.passengers.splice(paxIndex, 1);
                                            paxIndexPurgeList.push(paxIndex);
                                        }
                                    });
                                    if (paxIndexPurgeList.length > 0) {
                                        // proceed with delete if there's a pax item to be purged..
                                        catalogItem.passengers = _this.INDRA_purgeListItemsByIndex(catalogItem.passengers, paxIndexPurgeList);
                                    }
                                    if (catalogItem.passengers.length === 0) {
                                        // removes catalog if no passengers were left on the catalogItem..
                                        catalogIndexPurgeList_1.push(catalogIndex);
                                    }
                                }
                            });
                            if (catalogIndexPurgeList_1.length > 0) {
                                // proceed with delete if there's a catalog to be purged..
                                ancillaryItem.catalog = _this.INDRA_purgeListItemsByIndex(ancillaryItem.catalog, catalogIndexPurgeList_1);
                            }
                            if (ancillaryItem.catalog.length === 0) {
                                // removes bundle if no catalog were left for the bundle.
                                bundleIndexPurgeList_1.push(bundleIndex);
                            }
                        }
                    });
                }
            });
            if (bundleIndexPurgeList_1.length > 0) {
                // proceed with delete if there's a bundle to be purged..
                ancillaryData.bundleList = this.INDRA_purgeListItemsByIndex(ancillaryData.bundleList, bundleIndexPurgeList_1);
            }
        }
        return ancillaryData;
    };
    INDRAAncillariesService.prototype.INDRA_isPassengerPrmEligible = function (passenger, ineligibleSSRList) {
        var returnFlag = true;
        if (passenger.prm) {
            passenger.prm.forEach(function (prmItem) {
                if (ineligibleSSRList.includes(prmItem.type)) {
                    returnFlag = false;
                }
            });
        }
        return returnFlag;
    };
    INDRAAncillariesService.prototype.INDRA_isFlightFareInfoEligible = function (flightFareInfomation, ineligibleSSRList) {
        var returnFlag = true;
        if (flightFareInfomation && flightFareInfomation.ancillaries) {
            flightFareInfomation.ancillaries.forEach(function (ancillary) {
                if (ineligibleSSRList.includes(ancillary)) {
                    returnFlag = false;
                }
            });
        }
        return returnFlag;
    };
    INDRAAncillariesService.prototype.INDRA_isCurrentPurchasedAncillariesEligible = function (flightId, segmentId, paxId, ineligibleSSRList) {
        var returnFlag = true;
        var ancillaries = [];
        ancillaries = this.bookingService.INDRA_getPaxPurchasedFeaturesOnFlightSegment(flightId, segmentId, paxId);
        ancillaries.forEach(function (ancillaryItem) {
            if (ineligibleSSRList.includes(ancillaryItem.code)) {
                returnFlag = false;
            }
        });
        return returnFlag;
    };
    INDRAAncillariesService.prototype.INDRA_purgeListItemsByIndex = function (itemList, indexList) {
        // highest index must be deleted first.
        indexList.sort(function (a, b) { return b - a; });
        indexList.forEach(function (indexNum) {
            itemList.splice(indexNum, 1);
        });
        return itemList;
    };
    /**
     * Checks if the passenger has certain ancillary code,
     * in an ancillary group, included in prm
     * @param ancillaryGroupCode ancillary group code
     * @param idPax passenger's id
     * @param bookedTrip active booked trip
     */
    INDRAAncillariesService.prototype.INDRA_checkIfPassengerAlreadyPurchasedPrm = function (ancillaryGroupCode, idPax, bookedTrip) {
        var flag = false;
        var group = this.bookingService.INDRA_getSSRAvailableForGroup(ancillaryGroupCode);
        bookedTrip.data.infoPax.listPax.forEach(function (pax) {
            if (pax.prm) {
                pax.prm.forEach(function (prm) {
                    if (pax.idPax === idPax && group && group.includes(prm.type)) {
                        flag = true;
                    }
                });
            }
        });
        return flag;
    };
    /**
     * Checks if the passenger has specific ancillary code included in prm
     * @param ancillaryCode 4 character ancillary code
     * @param idPax passenger's id
     * @param bookedTrip active booked trip
     */
    INDRAAncillariesService.prototype.INDRA_checkIfPassengerAlreadyPurchasedSpecificPrm = function (ancillaryCode, idPax, bookedTrip) {
        var flag = false;
        bookedTrip.data.infoPax.listPax.forEach(function (pax) {
            if (pax.prm) {
                pax.prm.forEach(function (prm) {
                    if (pax.idPax === idPax && prm.type === ancillaryCode) {
                        flag = true;
                    }
                });
            }
        });
        return flag;
    };
    INDRAAncillariesService.prototype.INDRA_getAncillaryConfig = function (extrasType) {
        switch (extrasType) {
            case EXTRAS_ANCILLARY_BAG:
                return PURCHASED_ANCILLARY_BAG;
            case EXTRAS_ANCILLARY_EQUIPMENT:
                return PURCHASED_ANCILLARY_EQUIPMENT;
            case EXTRAS_ANCILLARY_MEAL:
                return PURCHASED_ANCILLARY_EXTRA_MEAL;
            case EXTRAS_ANCILLARY_ANIMAL:
                return PURCHASED_ANCILLARY_EXTRA_ANIMAL;
            case EXTRAS_ANCILLARY_FAST_TRACK:
                return PURCHASED_ANCILLARY_EXTRA_FAST_TRACK;
            case EXTRAS_ANCILLARY_LOUNGE:
                return PURCHASED_ANCILLARY_EXTRA_LOUNGE;
            case EXTRAS_ANCILLARY_MUSICAL:
                return PURCHASED_ANCILLARY_EXTRA_MUSICAL;
            case EXTRAS_ANCILLARY_SEAT:
                return PURCHASED_ANCILLARY_SEAT;
            case EXTRAS_ANCILLARY_PREF_BOARD:
                return PURCHASED_ANCILLARY_PREF_BOARD;
            case EXTRAS_ANCILLARY_PACK_PAAG:
                return PURCHASED_ANCILLARY_PACK_PAAG;
            case EXTRAS_ANCILLARY_PACK_PAAD:
                return PURCHASED_ANCILLARY_PACK_PAAD;
            case EXTRAS_ANCILLARY_PACK_PAAA:
                return PURCHASED_ANCILLARY_PACK_PAAA;
            case EXTRAS_ANCILLARY_PACK_PAAE:
                return PURCHASED_ANCILLARY_PACK_PAAE;
            case EXTRAS_ANCILLARY_PACK_PAAF:
                return PURCHASED_ANCILLARY_PACK_PAAF;
            case EXTRAS_ANCILLARY_PACK_PAAB:
                return PURCHASED_ANCILLARY_PACK_PAAB;
            case EXTRAS_ANCILLARY_PACK_PAAC:
                return PURCHASED_ANCILLARY_PACK_PAAC;
            case EXTRAS_ANCILLARY_PACK_PAAH:
                return PURCHASED_ANCILLARY_PACK_PAAH;
            case EXTRAS_ANCILLARY_PACK_PAAO:
                return PURCHASED_ANCILLARY_PACK_PAAO;
            case EXTRAS_ANCILLARY_PACK_PAAT:
                return PURCHASED_ANCILLARY_PACK_PAAT;
            case EXTRAS_ANCILLARY_PACK_PAAI:
                return PURCHASED_ANCILLARY_PACK_PAAI;
            case EXTRAS_ANCILLARY_PACK_PAAQ:
                return PURCHASED_ANCILLARY_PACK_PAAQ;
            case EXTRAS_ANCILLARY_PACK_PAAR:
                return PURCHASED_ANCILLARY_PACK_PAAR;
            case EXTRAS_ANCILLARY_PACK_PBAT:
                return PURCHASED_ANCILLARY_PACK_PBAT;
            case EXTRAS_ANCILLARY_PACK_PBAA:
                return PURCHASED_ANCILLARY_PACK_PBAA;
            case EXTRAS_ANCILLARY_PACK_PBAB:
                return PURCHASED_ANCILLARY_PACK_PBAB;
            default:
                return undefined;
        }
    };
    /************************* PHASE 2 codes *************************/
    INDRAAncillariesService.prototype.INDRA_generateGenericPassengerList = function (passengersCount) {
        var _a;
        var passengerTypeList = [PAX_TYPE_ADULT, PAX_TYPE_CHILD, PAX_TYPE_INFANT, PAX_TYPE_YOUNG_ADULT];
        var typeToNameMap = (_a = {},
            _a[PAX_TYPE_ADULT] = 'Adult',
            _a[PAX_TYPE_CHILD] = 'Child',
            _a[PAX_TYPE_INFANT] = 'Infant',
            _a[PAX_TYPE_YOUNG_ADULT] = 'Young Adult',
            _a);
        var passengerList = [];
        passengerTypeList.forEach(function (type) {
            if (passengersCount[type]) {
                var passengerCountPerType = passengersCount[type];
                for (var i = 0; i < passengerCountPerType; i++) {
                    passengerList.push({
                        name: typeToNameMap[type] + ' ' + (i + 1),
                        type: PASSENGER_TYPE_TO_CODE_MAP[type],
                        ancillaryStatus: true
                    });
                }
            }
        });
        return passengerList;
    };
    INDRAAncillariesService.prototype.INDRA_getAncillaryCodeListOfBasicAncillary = function (basicAncillaryCode) {
        if (!basicAncillaryCode)
            return [];
        switch (basicAncillaryCode.toUpperCase()) {
            case BASIC_ANCILLARY_CODES_HAND_BAGGAGE:
                return ANCILLARY_GROUP_HAND_BAGGAGE_LIST;
            case BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE:
                return ANCILLARY_GROUP_HOLD_BAGGAGE_LIST;
            case BASIC_ANCILLARY_CODES_SEAT_RESERVATION:
                return ANCILLARY_GROUP_SEAT_RESERVATION_LIST;
            case BASIC_ANCILLARY_CODES_MEALS:
                return ANCILLARY_GROUP_MEAL_LIST;
            case BASIC_ANCILLARY_CODES_PREMIUM_BOARDING:
                return ANCILLARY_GROUP_PREMIUM_BOARDING_LIST;
            case BASIC_ANCILLARY_CODES_FASTTRACK:
                return ANCILLARY_GROUP_FAST_TRACK_LIST;
            case BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN:
                return ANCILLARY_GROUP_PRIORITY_CHECK_IN_LIST;
            case BASIC_ANCILLARY_CODES_PREMIUM_CUSTOMER_CENTER:
                return ANCILLARY_GROUP_PREMIUM_CUSTOMER_CENTER_LIST;
            case BASIC_ANCILLARY_CODES_LOUNGE:
                return ANCILLARY_GROUP_LOUNGE_LIST;
            case BASIC_ANCILLARY_CODES_KIOSK:
                return ANCILLARY_GROUP_KIOSK_LIST;
            case BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE:
                return ANCILLARY_GROUP_PRIORITY_BAGGAGE_LIST;
            case BASIC_ANCILLARY_CODES_MILES:
                return ANCILLARY_GROUP_MILES_LIST;
            case BASIC_ANCILLARY_CODES_PREMIUM_BAGGAGE:
            case BASIC_ANCILLARY_CODES_FLIGHT_CANCELLATION:
            case BASIC_ANCILLARY_CODES_FLIGHT_CHANGES:
            case BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS:
            default: return [];
        }
    };
    INDRAAncillariesService.prototype.getAncillaryIncludedPerBasicAncillary = function (basicAncillaryCode, ancillaryList) {
        var ancillaryGroupList = this.INDRA_getAncillaryCodeListOfBasicAncillary(basicAncillaryCode);
        var relatedAncillaries = [];
        if (ancillaryGroupList && ancillaryGroupList.length > 0) {
            relatedAncillaries = ancillaryList.filter(function (ancillary) { return ancillaryGroupList.includes(ancillary); });
        }
        return relatedAncillaries;
    };
    INDRAAncillariesService.prototype.getFeaturePerBrand = function (featureCode, brandsList) {
        var _this = this;
        var featureTemplate = INDRA_getFeatureForTAC(featureCode, null, null, null);
        var featureBrandMatrix = {
            code: featureCode,
            icon: featureTemplate.icon,
            label: featureTemplate.label,
            labelTranslationKey: featureTemplate.labelTranslationKey,
            brands: null
        };
        // iterate over the list of brands
        var brandsWithFeature = [];
        if (brandsList && brandsList.length > 0) {
            brandsList.forEach(function (brand) {
                var featureBrand = {
                    name: brand.name,
                    feature: null
                };
                // check if in basic ancillaries object
                var basicAncillaries = brand.ancillaries;
                var basicAncillaryObj = null;
                if (basicAncillaries && basicAncillaries.length > 0) {
                    var basicAncillaryFilteredList = basicAncillaries.filter(function (basicAncillary) { return basicAncillary.code === featureCode; });
                    basicAncillaryObj = basicAncillaryFilteredList && basicAncillaryFilteredList.length ?
                        basicAncillaryFilteredList[0] : null;
                }
                var feature;
                if (basicAncillaryObj) {
                    var relatedIncludedAncillaries = _this.getAncillaryIncludedPerBasicAncillary(featureCode, brand.includedAncillaries);
                    var featureObj = {
                        id: featureTemplate.id,
                        code: featureCode,
                        label: featureTemplate.label,
                        labelTranslationKey: featureTemplate.labelTranslationKey,
                        extra: false,
                        type: (basicAncillaryObj.free ? 'added' : (basicAncillaryObj.available ? 'available' : 'unavailable')),
                        icon: featureTemplate.icon,
                        price: basicAncillaryObj.amount,
                        currency: basicAncillaryObj.currency,
                        description: featureTemplate.description,
                        includedAncillaries: relatedIncludedAncillaries,
                        available: basicAncillaryObj.available,
                        free: basicAncillaryObj.free
                    };
                    feature = featureObj;
                }
                else {
                    var relatedIncludedAncillaries = _this.getAncillaryIncludedPerBasicAncillary(featureCode, brand.includedAncillaries);
                    if (relatedIncludedAncillaries && relatedIncludedAncillaries.length > 0) {
                        var featureObj = {
                            id: featureTemplate.id,
                            code: featureCode,
                            label: featureTemplate.label,
                            labelTranslationKey: featureTemplate.labelTranslationKey,
                            extra: false,
                            type: 'added',
                            icon: featureTemplate.icon,
                            price: -1,
                            currency: null,
                            description: featureTemplate.description,
                            includedAncillaries: relatedIncludedAncillaries
                        };
                        feature = featureObj;
                    }
                    else {
                        // not available/included for the current brand
                        var featureObj = {
                            id: featureTemplate.id,
                            code: featureCode,
                            label: featureTemplate.label,
                            labelTranslationKey: featureTemplate.labelTranslationKey,
                            extra: false,
                            type: 'unavailable',
                            icon: featureTemplate.icon,
                            price: -1,
                            currency: null,
                            description: null,
                            includedAncillaries: null
                        };
                        feature = featureObj;
                    }
                }
                // handle special cases for feature (to be inserted in the description)
                // Unavailable messages
                if (!feature.type || feature.type === 'unavailable') {
                    var availabilityDescription = '';
                    if (featureCode === BASIC_ANCILLARY_CODES_FLIGHT_CHANGES) {
                        availabilityDescription = 'ancillaries.description.NotRefundable';
                    }
                    else if (featureCode === BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS) {
                        availabilityDescription = 'ancillaries.description.NotRefundableWithExceptions';
                    }
                    else {
                        availabilityDescription = 'ancillaries.description.NotAvailable';
                    }
                    feature['description'] = availabilityDescription;
                }
                else {
                    /* 	- Kiosk (number + <span>newspaper/magazine</span>)
                     * 	- Hand baggage display (display piece x bag weight)
                     *	- Checked baggage display (display piece x bag weight)
                     *	- Miles display (display miles) - get miles from response
                     *	- Refund/Cancellation amount if applicable
                     */
                    if (featureCode === BASIC_ANCILLARY_CODES_KIOSK ||
                        featureCode === BASIC_ANCILLARY_CODES_HAND_BAGGAGE ||
                        featureCode === BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE) {
                        var specificAncillary = (feature.includedAncillaries && feature.includedAncillaries.length > 0) ? feature.includedAncillaries[0] : '';
                        feature['description'] = featureTemplate.specificAncillaryLabels[specificAncillary];
                    }
                    else if (featureCode === BASIC_ANCILLARY_CODES_MILES) {
                        var miles = brand.miles ? brand.miles : 0;
                        feature['description'] = miles.toString();
                    }
                    else if (featureCode === BASIC_ANCILLARY_CODES_FLIGHT_CANCELLATION ||
                        featureCode === BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS) {
                        var amount = (brand['refounds-fee'] && brand['refounds-fee'].length > 0) ? brand['refounds-fee'][0] : 0;
                        feature['description'] = amount.toString();
                    }
                }
                if (featureCode === BASIC_ANCILLARY_CODES_MEALS && brand['fareInfo-segment']) {
                    feature['segmentIncluded'] = brand['fareInfo-segment'].slice();
                }
                featureBrand['feature'] = feature;
                brandsWithFeature.push(featureBrand);
            });
        }
        featureBrandMatrix['brands'] = brandsWithFeature;
        return featureBrandMatrix;
    };
    /**
     * This massages the data to remove catalog items that are not provided
     * @param ancillaryData: INDRAAncillary
     *  @param retainCatalogList: array
     */
    INDRAAncillariesService.prototype.INDRA_retainAncillaryCatalogs = function (bundleList, retainCatalogList) {
        if (bundleList && bundleList.length) {
            var filteredBundleList = bundleList.filter(function (bundle) { return bundle && bundle.ancillaryList.filter(function (ancillary) { return (retainCatalogList.includes(ancillary.type)); }).length > 0; });
            return filteredBundleList;
        }
        else {
            return [];
        }
    };
    // request API for External Reservation
    INDRAAncillariesService.prototype.INDRA_addExternalReservation = function (request, provider) {
        if (provider === EXTRAS_ANCILLARY_CARBON_OFFSET) {
            if (MOCK_STATUS.CARBON_OFFSET) {
                return this.http.get(MOCK_URL_CARBON_OFFSET);
            }
            else {
                return this.api.INDRA_post(URL_BFM_EXTERNAL_RESERVATION, request);
            }
        }
        else if (provider === EXTRAS_ANCILLARY_STOPOVER_LISBOA_CARD) {
            if (MOCK_STATUS.LISBOA_CARD) {
                return this.http.get(MOCK_URL_LISBOA_CARD);
            }
            else {
                return this.api.INDRA_post(URL_BFM_EXTERNAL_RESERVATION, request);
            }
        }
        else if (provider === EXTRAS_ANCILLARY_STOPOVER_AIRPORT_TRANSFERS) {
            if (MOCK_STATUS.AIRPORT_TRANSFERS) {
                return this.http.get(MOCK_URL_AIRPORT_TRANSFERS);
            }
            else {
                return this.api.INDRA_post(URL_BFM_EXTERNAL_RESERVATION, request);
            }
        }
        else if (provider === EXTRAS_ANCILLARY_INSURANCE) {
            if (MOCK_STATUS.INSURANCE) {
                return this.http.get(MOCK_URL_INSURANCE_RESERVATIONS);
            }
            else {
                return this.api.INDRA_post(URL_BFM_EXTERNAL_RESERVATION, request);
            }
        }
        else if (provider === EXTRAS_ANCILLARY_STOPOVER_SIGHTSEEING_TOURS) {
            if (MOCK_STATUS.SIGHTSEEING_TOURS) {
                return this.http.get(MOCK_URL_SIGHTSEEING_TOURS);
            }
            else {
                return this.api.INDRA_post(URL_BFM_EXTERNAL_RESERVATION, request);
            }
        }
        else if (provider == EXTRAS_ANCILLARY_GUARANTEE_FUND) {
            if (MOCK_STATUS.DANISH_FUND) {
                return this.http.get(MOCK_URL_DANISH_FUND);
            }
            else {
                return this.api.INDRA_post(URL_BFM_EXTERNAL_RESERVATION, request);
            }
        }
        else {
            return this.api.INDRA_post(URL_BFM_EXTERNAL_RESERVATION, request);
        }
    };
    // remove API for External Reservation
    INDRAAncillariesService.prototype.INDRA_removeExternalReservation = function (provider) {
        return this.api.INDRA_get(URL_REMOVE_EXTERNAL_RESERVATION + provider);
    };
    INDRAAncillariesService.prototype.INDRA_removeStopoverExtra = function (provider, stopoverCode, stopoverInfoCode) {
        return this.api.INDRA_get(URL_REMOVE_EXTERNAL_RESERVATION + provider + '/' + stopoverCode + '/' + stopoverInfoCode);
    };
    INDRAAncillariesService.prototype.INDRA_removeAllExternalReservation = function () {
        return this.api.INDRA_get(URL_REMOVE_ALL_EXTERNAL_RESERVATION);
    };
    INDRAAncillariesService.prototype.INDRA_removeSpecificExternalReservation = function (provider, idReservation) {
        return this.api.INDRA_get(URL_REMOVE_SPECIFIC_EXTERNAL_RESERVATION + provider + '/' + idReservation);
    };
    INDRAAncillariesService.prototype.INDRA_removeExternalReservationByExtraInfo = function (provider, params) {
        return this.api.INDRA_get(URL_REMOVE_EXTERNAL_RESERVATION_BY_EXTRA_INFO + provider + '/' + params);
    };
    INDRAAncillariesService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAAncillariesService_Factory() { return new INDRAAncillariesService(i0.inject(i1.HttpClient), i0.inject(i2.INDRAApiService), i0.inject(i3.INDRABookingService), i0.inject(i4.INDRAParallelService)); }, token: INDRAAncillariesService, providedIn: "root" });
    return INDRAAncillariesService;
}());
export { INDRAAncillariesService };
